const env = require('./env');
const { LOCAL, OAUTH, AGCO_CUSTOMER_PORTAL, AGCO_DEALER_PORTAL } = require('./auth/protocols');

function isTrue(value) {
  // Node sets env variables as strings for the backend
  // while webpack sets them as booleans for the frontend.
  return value === true || value === 'true';
}

const { AUTH_PROTOCOL, ENABLE_DATADOG_MONITORING, ENABLE_SENTRY_MONITORING } = env;

const features = {
  localAuth: !AUTH_PROTOCOL || AUTH_PROTOCOL === LOCAL,
  oauthAuth: AUTH_PROTOCOL === OAUTH,
  agcoCustomerPortalAuth: AUTH_PROTOCOL === AGCO_CUSTOMER_PORTAL,
  agcoDealerPortalAuth: AUTH_PROTOCOL === AGCO_DEALER_PORTAL,
  datadogMonitoring: isTrue(ENABLE_DATADOG_MONITORING),
  sentryMonitoring: isTrue(ENABLE_SENTRY_MONITORING),
};

module.exports = features;
